import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { numberRegex } from 'src/app/resources/Constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DiscountingConfig, Tabs } from 'src/app/models/tool.model';

export interface AddSetModalValue {
  currencyValue: string;
  recoveryRateValue: string;
}

@Component({
    selector: 'app-add-set-modal',
    templateUrl: './add-set-modal.component.html',
    styleUrls: ['./add-set-modal.component.scss'],
    standalone: false
})
export class AddSetModalComponent implements OnInit {

  @Input() tabs: Tabs;
  @Output() closeModal: EventEmitter<{tabsConfig: DiscountingConfig[], activeModal: NgbActiveModal}> = new EventEmitter();
  regexForNumber = numberRegex;
  submitted = false;
  isRecoveryRateNotValid = false;

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() { }

  /**
   * Returns the value of the Recovery Rate input
   * @param recoveryRate Entered value
   */

  getRecoveryRateValue(recoveryRate: string) {
    this.isRecoveryRateNotValid = false;
    if (recoveryRate?.length > 0) {
      const regex = RegExp(numberRegex);
      const isValidNumber = regex.test(recoveryRate);
      if (!isValidNumber) {
        this.isRecoveryRateNotValid = true;
      }
    }
  }

  /**
   * Submit modal. Creates the object to send to the parent component and sends it with the event
   */

  onSave() {
    this.submitted = true;
    if (!this.tabs.tab_configuration.some(item => item.name === 'Currency' && !item.choosen_value && !this.isRecoveryRateNotValid)) {
      const createSetdBody: DiscountingConfig[] = this.tabs.tab_configuration.map(item => {
        return {
          name: item.name,
          value: item.choosen_value ? item.choosen_value.replace('.', ',') : null
        };
      });
      this.closeModal.emit({ tabsConfig: createSetdBody, activeModal: this.activeModal });
    }
  }

  /**
   * Return the input name entered in the currency editable_select
   */

  addCurrency(name: string) {
    return name;
  }
}
